import { statusStyles } from "utils";

const OrderStatusBadge = ({ status, className = '' }: { status: string; className?: string }) => (
  <span className={`px-5 py-3 rounded-md text-xs font-semibold ${statusStyles[status] || 'bg-gray-100 text-gray-800'} ${className}`}>
    {status}
  </span>
);

export default OrderStatusBadge; 